goog.provide('el8.appchart.refpanel.meds');

goog.require('el8.appchart.actions.dcMedOrder');
goog.require('el8.appchart.actions.medOrder');
goog.require('el8.appchart.actions.medOrderThread');
goog.require('el8.appchart.medsHx.main');
goog.require('el8.appchart.metrics');
goog.require('el8.appchart.permissions');
goog.require('el8.appchart.refpanel.setup');
goog.require('el8.model.identify');
goog.require('el8.ptdata.rxHistoryDownloadSummaries');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.refpanel.meds');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appchart.refpanel.RefPanelSection');
goog.require('el8.appchart.permissions');

el8.appchart.refpanel.meds = (function() {

    var _Sections = ['perm-rx', 'perm-otc', 'recent'];
    var SELECTED_CLASS = 'el8BlueHighlight';
    var HIGHLIGHT_CLASS = 'el8Highlight';

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('meds');

    var that = new el8.appchart.refpanel.RefPanelSection({

        loadFn: function(callbackFn) {
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('fetchMedsRefPanel'),
                success: function(data) {
                    var allResults = [];
                    allResults.addArray(data['perm_rx_threads']);
                    allResults.addArray(data['perm_otc_threads']);
                    allResults.addArray(data['recent_orders']);
                    for (var i=0; i<allResults.length; i++) {
                        var entitySet = el8.ptdata.getEntitySet(allResults[i]['model_class']);
                        entitySet.create(allResults[i], true);
                    }
                    reportOnFirstLoad();
                    if (callbackFn) { callbackFn(); }
                }
            });
        },
        initFn: function() {
            for (var i=0; i<_Sections.length; i++) {
                var name = _Sections[i];
                var $sectionContainer = $('#'+name+'-meds-section');
                if (name !== 'recent') {
                    if (name === "perm-rx") {
                        $sectionContainer.append(
                          el8.template.appchart.refpanel.meds.addNewAndCheckPMPTrigger({
                                'bulkRefillEnabled': el8.appchart.medsHx.main.isBulkRefillEnabled(),
                                name: name
                          }));
                        var disabledPMP = $('.check-pmp-tooltip');
                        if (disabledPMP.length !== 0) {
                            el8.service.tooltip.create({
                              anchor: disabledPMP,
                                text: 'PMP only available to providers.'
                            });
                        }
                    } else {
                        $sectionContainer.append(
                            el8.template.appchart.refpanel.meds.addNewTrigger({
                              'bulkRefillEnabled': el8.appchart.medsHx.main.isBulkRefillEnabled(),
                              name: name
                        }));
                    }
                }
                // Make panels collapsible (even if empty).
                el8.uiwidget.collapsible({
                    container: $sectionContainer,
                    triggerElt: $('#'+name+"-meds-summary-header"),
                    statusElt: $('#'+name+"-meds-summary-status")
                });
                that.addContainer($sectionContainer);
            }
            that._bindTriggers();
        },

        dataRenderers: [
            {
                entitySet: el8.ptdata.medOrderThreads,
                renderFn: _.debounce(function() {
                    that._renderSection('perm-rx');
                    that._renderSection('perm-otc');
                }, 3000),
                events: [{ eventName: 'all' }]
            }, {
                entitySet: el8.ptdata.medOrders,
                renderFn: function() {
                    that._renderSection('recent');
                },
                events: [{ eventName: 'all' }]
            }, {
                entitySet: el8.ptdata.dcMedOrders,
                renderFn: function() {
                    that._renderSection('recent');
                },
                events: [{ eventName: 'all' }]
            }, {
                entitySet: el8.ptdata.rxHistoryDownloadSummaries,
                renderFn: function() {
                    that.renderRxDownload();
                },
                events: [{ eventName: 'all' }]
            }
        ]

    });

    that.highlightThread = function(threadId) {
        var container = $('#perm-rx-meds-summary, #perm-otc-meds-summary');
        var $elt = $('.med-item[data-type="thread"][data-id="'+threadId+'"]', container);
        if ($elt.length) {
            $elt.addClass(SELECTED_CLASS);
            $.el8_setTimeout(function() {
                $elt.removeClass(SELECTED_CLASS);
            }, 5000);
        }
    };

    that.highlightOrder = function(orderId) {
        var container = $('#recent-meds-summary');
        var $elt = $('.med-item[data-type="med-order"][data-id="'+orderId+'"]', container);
        if ($elt.length) {
            $elt.addClass(SELECTED_CLASS);
            $.el8_setTimeout(function() {
                $elt.removeClass(SELECTED_CLASS);
            }, 5000);
        }
    };

    that.highlightThreadRxDownload = function(threadId) {
        var container = $('#perm-rx-meds-summary, #perm-otc-meds-summary');
        var $elt = $('.med-item[data-type="thread"][data-id="'+threadId+'"]', container);
        if ($elt.length) {
            $elt.addClass(HIGHLIGHT_CLASS);
        }
    };

    that.highlightOrderRxDownload = function(orderId) {
        var container = $('#recent-meds-summary');
        var $elt = $('.med-item[data-type="med-order"][data-id="'+orderId+'"]', container);
        if ($elt.length) {
            $elt.addClass(HIGHLIGHT_CLASS);
        }
    };

    // debouncing here so that rendering many items in the LHS will only rerender rx downloads 1x
    // See static/js/legacy/el8/appchart/mainFeeds/outstanding.js#34 for an example of when this might happen
    that.renderRxDownload = _.debounce(function() {
        that._renderRxDownloadOrders();
        that._renderRxDownloadThreads();
    }, 1000);
    that._renderRxDownloadOrders = function() {
        var toHighlight = el8.ptdata.rxHistoryDownloadSummaries.getAllUnsignedMeds();
        var ordersToHighlight = toHighlight['orderIds'];
        for (var i=0; i<ordersToHighlight.length; i++) {
            that.highlightOrderRxDownload(ordersToHighlight[i]);
        }
    };
    that._renderRxDownloadThreads = function() {
        var toHighlight = el8.ptdata.rxHistoryDownloadSummaries.getAllUnsignedMeds();
        var threadsToHighlight = toHighlight['threadIds'];
        for (var i=0; i<threadsToHighlight.length; i++) {
            that.highlightThreadRxDownload(threadsToHighlight[i]);
        }
    };

    that.refreshAll = function(callbackFn) {
        // call this when we expect to fetch rx downloads: the medsSummary URL
        // returns different results than calling medOrderThreads.load()
        that._loadFn(function() {
            that.render();
            if (callbackFn) { callbackFn(); }
        });

    };

    /**
     * Helper rendering functions
     */
    that._renderSection = function(name) {

        var items = that.getSectionItemsByName(name);
        $('#'+name+'-meds-summary').html(that._getSectionHtml(name, items));
        $('#'+name+'-meds-section').removeClass('el8Loading');

        if (name.startswith('perm')) {
            that._renderRxDownloadThreads();
        } else {
            that._renderRxDownloadOrders();
        }
    };

    that.getSectionItemsByName = function(name) {
        if (name === 'perm-rx') {
            return el8.ptdata.medOrderThreads.getSortedPermRx(true); // alpha-sort

        } else if (name === 'perm-otc') {
            return el8.ptdata.medOrderThreads.getSortedPermOtc(true); // alpha-sort

        } else if (name === 'recent') {
            var minDate = el8.appchart.mainFeeds.chart.getLastVisitDate(el8Globals['NUM_RECENT_VISITS']) || el8Globals['INIT_RECENT_CUTOFF_DATE'];
            var recentOrders = el8.ptdata.medOrders.all().filter(function(o) {
                return (o.getDocumentDate().getTime() >= minDate.getTime())
                    && !o.isDocumentMed() && !o.isRxDownload() && o.isSignedOff();
            });
            recentOrders.addArray(el8.ptdata.dcMedOrders.all().filter(function(o) {
                return (o.getDocumentDate().getTime() >= minDate.getTime())
                    && !o.isDocumented() && o.isSignedOff();
            }));
            return recentOrders.sort(function(a, b) {
                var cmp = (b.is('DiscontinueMedOrder') ? b.getDiscontinueDate().getTime() :
                        b.getStartDate().getTime()) -
                    (a.is('DiscontinueMedOrder') ? a.getDiscontinueDate().getTime() :
                        a.getStartDate().getTime());
                if (cmp > 0) { return 1; }
                if (cmp < 0) { return -1; }
                return b.getId() - a.getId();
            });
        }
    };

    that._getSectionHtml = function(name, items) {
        var html = '';
        var item;
        var hasActions = true;
        for (var i=0; i<items.length; i++) {
            item = items[i];
            if (name === 'recent') {
                html += that._getOrderHtml(item, hasActions);
            } else {
                var num = i + 1;
                html += el8.template.appchart.refpanel.meds.thread({
                    num: num,
                    item: item.asSoyMap(),
                    shortStartDate: el8.service.tz.soyStr(item.getStartDate()),
                    hasActions: hasActions
                });
            }
        }
        return html;
    };

    // Either MedOrder or DiscontinueMedOrder
    that._getOrderHtml = function(item, hasActions) {
        var spec = {};
        spec['item'] = item.asSoyMap();
        spec['hasActions'] = hasActions;
        if (item.is('MedOrder')) {
            spec['startDate'] = el8.service.tz.soyStr(item.getStartDate());
        } else if (item.is('DiscontinueMedOrder')) {
            spec['dcDate'] = el8.service.tz.soyStr(item.getDiscontinueDate());
        }
        return el8.template.appchart.refpanel.meds.order(spec);
    };

    that._bindTriggers = function() {
        that._threadTriggersActive = true;
        var container = $(_Sections.map(function(name) {
            return '#'+name+'-meds-summary';
        }).join(', '));
        container.on('click', '.details-trigger',  function(e) {
            var $elt = $(this).closest('.med-item');
            var itemId = $elt.attr('data-id')*1;
            var type = $elt.attr('data-type');
            if (type === 'thread') {
                if (!that._threadTriggersActive) { return; }
                el8.appchart.medsHx.main.show({threadId: itemId});
            } else if (type === 'med-order') {
                el8.appchart.medsHx.main.show({medOrderId: itemId});
            } else if (type === 'dc-med-order') {
                el8.appchart.medsHx.main.show({dcMedOrderId: itemId});
            }
            el8.appchart.refpanel.actionsMenu.hide();
            return false;

        }).on('click', '.order-actions-trigger',  function(e) {
            if (el8Globals.TEASE) {
                return false;
            }
            var itemId = $(this).attr('data-id');
            var item, menu;
            if (el8.model.idToModelClass(itemId) === 'MedOrder') {
                item = el8.ptdata.medOrders.getById(itemId);
                menu = el8.appchart.actions.medOrder({item: item, amplitudeSource: $(this).parent().attr('id')});
            } else if (el8.model.idToModelClass(itemId) === 'DiscontinueMedOrder') {
                item = el8.ptdata.dcMedOrders.getById(itemId);
                menu = el8.appchart.actions.dcMedOrder({item: item, amplitudeSource: $(this).parent().attr('id')});
            }
            el8.appchart.refpanel.actionsMenu.display(
                $(this), item, {top: 17, left: 5}, menu);
            return false;

        }).on('click', '.thread-actions-trigger',  function(e) {
            if (!that._threadTriggersActive) { return; }
            var itemId = $(this).attr('data-id');
            var item = el8.ptdata.medOrderThreads.getById(itemId);
            var menu = el8.appchart.actions.medOrderThread({
                item: item,
                isMedsHistory: false,
                amplitudeSource: $(this).parent().attr('id')
            });
            el8.appchart.refpanel.actionsMenu.display(
                $(this), item, {top: 17, left: 5}, menu);
            return false;
        });

        $('#refBoardContainer').on('click', '.meds-list-actions-trigger',  function(e) {
            var name = $(this).attr("_section");
            var menu = [
                {
                    actionText: 'Export ' +
                        (name === 'perm-rx' ? 'Rx' : (name === 'perm-otc') ? 'OTC' : 'Recent')
                         + ' Meds to Note',
                    actionFn: function() { el8.appchart.mgr.notes.addMedsListSnapshot(name); }
                },
                {
                    actionText: 'Print Current Meds List',
                    actionFn: function() {
                        el8.appchart.printService.open({
                            attachmentId: 'MedsList',
                            printFn: el8.appchart.mgr.notes.printMedsList
                        });
                    }
                },
                {
                    actionText: 'View All Meds History',
                    actionFn: function() { el8.appchart.medsHx.main.show(); }
                },
                {
                    actionText: "Document Meds",
                    actionFn: function() { el8.appchart.dialog.ordermed.document.show(); }
                }
            ];
            el8.appchart.refpanel.actionsMenu.display(
                $(this), null,
                {'top': 17, 'left': 20},
                menu
            );
            return false;
        });
    };

    return that;

})();
